import { useEffect, useState} from 'react';
import Layout from "../Shared/Layout";
import TableDashboard from "./TableDashboard";
import { fetchTotalCount } from "../service/api/accountService";
import { getVolumeTransaction, getTotalCashPrivate, getTotalCashPublic } from "../service/api/TransactionService";
import CustomerForm from './Account/AccountForm/CustomerForm';
import OrderForm from './Order/OrderForm';
import FormulaireRfi from './RFIS/FormulaireRfi';
import {ChartDonutTransaction} from './Transactions/ChartDonutTransactions';
import useSelectedDomain from '../service/Hooks/useSelectedDomain';
import {ChartDonutTitle} from './Titles/ChartDonutTitle';
import { useUser } from '@clerk/clerk-react';
import { getUserRole } from '../service/api/AuthRoleService';
import { toast } from 'sonner';
import EventDetailsModal from '../Events/EventDetailsModal ';
import {ChartRepartitionClients} from './Account/ChartRepartionClients';
import FormulaireEvenement from '../Events/EventForm/FormulaireEvenement';
import { formatAmount } from '../service/utils/orderUtils';
import { formatCurrency } from '../service/utils/accountUtils';
import TransactionForm from './Transactions/TransactionForm/TransactionForm';
import SecurityForm from './Titles/SecurityForm';
import CourbeWrapper from '../Clients/CourbeWrapper';
import CountersSkeleton from '../skeleton/CountersSkeleton';

// ==================== COMPOSANTS ====================

// Composant DashboardHeader avec sélecteur d'année
const DashboardHeader = ({ 
  actions, 
  role, 
  selectedYear, 
  onYearChange,
  availableYears 
}) => {
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);

  const handleYearSelect = (year) => {
    onYearChange(year);
    setIsYearDropdownOpen(false);
  };

  return (
    <div className="dashboard-header">
      {/* Section fil d'Ariane et sélecteur d'année */}
      <div className="breadcrumb-section">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" className="breadcrumb-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                </svg>
                Tableau de bord
              </a>
            </li>
            <li className="breadcrumb-item active position-relative">
              <div className="year-selector">
                <button
                  className="btn btn-link p-0 text-decoration-none text-white d-flex align-items-center"
                  onClick={() => setIsYearDropdownOpen(!isYearDropdownOpen)}
                  aria-expanded={isYearDropdownOpen}
                >
                  <span className="current-year">{selectedYear}</span>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="ms-1">
                    <path d="M7 10l5 5 5-5z"/>
                  </svg>
                </button>

                {isYearDropdownOpen && (
                  <div className="year-dropdown show">
                    {availableYears.map((year) => (
                      <button
                        key={year}
                        className={`dropdown-item ${year === selectedYear ? 'active' : ''}`}
                        onClick={() => handleYearSelect(year)}
                      >
                        {year}
                        {year === selectedYear && (
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="ms-2">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </li>
          </ol>
        </nav>
      </div>

      {/* Section boutons d'actions */}
      <div className="actions-section">
        <div className="actions-grid">
          {actions.map((btn, i) => (
            <button 
              key={i} 
              className={`action-btn btn-${btn.color} rounded-4`} 
              onClick={btn.onClick}
              disabled={btn.disabled}
            >
              <span className="btn-content">
                <span className="btn-icon">{btn.icon}</span>
                <span className="btn-text">{btn.label}</span>
              </span>
            </button>
          ))}

          {(role === "admin+manager" || role === "admin") && (
            <button className="action-btn btn-warning rounded-4" onClick={actions.security}>
              <span className="btn-content">
                <span className="btn-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z"/>
                    <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z"/>
                  </svg>
                </span>
                <span className="btn-text">Nouveau Titre</span>
              </span>
            </button>
          )}
        </div>
      </div>

      <style>{`
        .dashboard-header {
          background: linear-gradient(135deg, #1a1f36 0%, #2d3748 100%);
          padding: 1.5rem 2rem;
          border-radius: 12px;
          margin-bottom: 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          color: white;
        }

        .year-selector {
          display: inline-block;
          position: relative;
        }

        .current-year {
          background: rgba(255, 255, 255, 0.2);
          padding: 0.25rem 0.75rem;
          border-radius: 20px;
          font-size: 0.875rem;
          font-weight: 600;
          transition: background 0.2s ease;
        }

        .year-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          min-width: 140px;
          background: white;
          border-radius: 8px;
          padding: 0.5rem 0;
          margin-top: 0.5rem;
          z-index: 1000;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
          animation: fadeIn 0.2s ease-out;
        }

        .year-dropdown .dropdown-item {
          color: #374151;
          padding: 0.5rem 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: all 0.2s ease;
          border: none;
          background: transparent;
          width: 100%;
          text-align: left;
        }

        .year-dropdown .dropdown-item:hover {
          background: #f3f4f6;
          color: #1f2937;
        }

        .year-dropdown .dropdown-item.active {
          background: #3b82f6;
          color: white;
        }

        .actions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
        }

        .action-btn {
          position: relative;
          overflow: hidden;
          border: none;
          padding: 0.875rem 1rem;
          border-radius: 8px;
          font-weight: 500;
          font-size: 0.875rem;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .action-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        .action-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none !important;
        }

        .btn-content {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          z-index: 1;
        }

        .btn-primary { background: linear-gradient(135deg, #007bff, #0056b3); }
        .btn-secondary { background: linear-gradient(135deg, #6c757d, #495057); }
        .btn-success { background: linear-gradient(135deg, #28a745, #1e7e34); }
        .btn-warning { background: linear-gradient(135deg, #ffc107, #e0a800); }
        .btn-danger { background: linear-gradient(135deg, #dc3545, #c82333); }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .dashboard-header {
            padding: 1rem;
          }
          
          .actions-grid {
            grid-template-columns: 1fr 1fr;
            gap: 0.75rem;
          }
          
          .current-year {
            font-size: 0.8rem;
            padding: 0.2rem 0.6rem;
          }
        }

        @media (max-width: 480px) {
          .actions-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

// Composant CountersSection amélioré
const CountersSection = ({ data, loading, selectedYear, hasData }) => {
  const cards = [
    {
      title: 'Total des Transactions (Bourses)',
      value: formatCurrency(data.transactionsTotal?.volume || 0),
      icon: (
        <img 
          src="https://www.bvm-ac.org/wp-content/uploads/elementor/thumbs/BVMAC-Logo-BA.fw_-ogk7i5vvwnmff84b2u6wo9rd6pa19yy4j24u796rsa.png" 
          alt="BVMAC" 
          className="counter-card-logo" 
        />
      ),
      badge: `Année ${selectedYear}`,
    },
    {
      title: 'Total AUC (Privé)',
      value: formatCurrency(data.totalAucPrivate?.totalCash || 0),
      icon: (
        <img 
          src="https://caa.cm/wp-content/uploads/2025/01/logo-caa.png" 
          alt="CAA" 
          className="counter-card-logo" 
        />
      ),
      badge: `Année ${selectedYear}`,
    },
    {
      title: 'Total AUC (Public)',
      value: formatCurrency(data.totalAucPublic?.totalCash || 0),
      icon: (
        <img 
          src="https://www.bvm-ac.org/wp-content/uploads/elementor/thumbs/BVMAC-Logo-BA.fw_-ogk7i5vvwnmff84b2u6wo9rd6pa19yy4j24u796rsa.png" 
          alt="BVMAC" 
          className="counter-card-logo" 
        />
      ),
      badge: `Année ${selectedYear}`,
    },
    {
      title: 'Nombre Total de comptes',
      value: formatAmount(data.totalCount || 0),
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="url(#total-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="url(#total-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="url(#total-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="url(#total-gradient)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <defs>
            <linearGradient id="total-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6B7280" />
              <stop offset="100%" stopColor="#9CA3AF" />
            </linearGradient>
          </defs>
        </svg>
      ),
      badge: `Année ${selectedYear}`,
    },
  ];

  // Skeleton pendant le chargement
  if (loading) {
    return <CountersSkeleton />;
  }

  if (!hasData) {
    return (
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-body text-center py-5">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.5">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h4 className="mt-3 mb-2 text-dark">Aucune donnée disponible pour {selectedYear}</h4>
              <p className="text-muted mb-4">
                Les statistiques pour cette année ne sont pas encore disponibles.
                <br />
                Sélectionnez une autre année ou revenez plus tard.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="counters-container">
      <div className="counters-grid">
        {cards.map((card, i) => (
          <div className="counter-card-wrapper" key={i}>
            <div className="card counter">
              <div className="year-badge">{card.badge}</div>
              <div className="counter-card-body">
                <div className="counter-card-icon">{card.icon}</div>
                <p className="counter-card-title">{card.title}</p>
                <div className="counter-card-amount-container">
                  {loading ? (
                    <div className="counter-loading">
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Chargement...</span>
                      </div>
                    </div>
                  ) : (
                    <h2 className="counter-card-amount">
                      <span className="counter-amount-badge">{card.value}</span>
                    </h2>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .counters-container {
          padding: 0.5rem 0;
          animation: fadeIn 0.5s ease-out;
        }

        .counters-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
        }

        .card.counter {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border: 1px solid #e9ecef;
          border-radius: 16px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          padding: 1.5rem 1rem;
          text-align: center;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .card.counter:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
          border-color: #182848;
        }

        .year-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(59, 130, 246, 0.1);
          color: #3b82f6;
          font-size: 0.7rem;
          font-weight: 600;
          padding: 0.2rem 0.6rem;
          border-radius: 12px;
        }

        .counter-card-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
        }

        .counter-card-icon {
          margin-bottom: 0.5rem;
        }

        .counter-card-logo {
          width: 60px;
          height: 60px;
          object-fit: contain;
          filter: grayscale(0.3);
          transition: filter 0.3s ease;
        }

        .card.counter:hover .counter-card-logo {
          filter: grayscale(0);
        }

        .counter-card-title {
          font-size: 0.9rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
          line-height: 1.4;
        }

        .counter-card-amount-container {
          margin-top: 0.5rem;
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .counter-loading {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .counter-amount-badge {
          background: linear-gradient(135deg, #4A90E2, #357ABD);
          color: white;
          border-radius: 50px;
          padding: 0.5rem 1rem;
          font-size: 0.85rem;
          font-weight: 600;
          box-shadow: 0 2px 8px rgba(74, 144, 226, 0.3);
          display: inline-block;
          white-space: nowrap;
        }

        .no-data-message {
          background: #f8f9fa;
          border-radius: 12px;
          border: 1px solid #e9ecef;
          padding: 2rem;
        }

        .empty-state {
          max-width: 500px;
          margin: 0 auto;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .counters-grid {
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
          }
        }

        @media (max-width: 480px) {
          .counters-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

// ==================== HOOK PERSONNALISÉ ====================
const useYearFilter = (initialYear = new Date().getFullYear()) => {
  const [selectedYear, setSelectedYear] = useState(initialYear);
  const [availableYears, setAvailableYears] = useState([]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);
    setAvailableYears(years);
  }, []);

  return { selectedYear, setSelectedYear, availableYears };
};

// ==================== COMPOSANT PRINCIPAL ====================
const DashboardPage = () => {
  // États et hooks
  const selectedDomain = useSelectedDomain();
  const { user } = useUser();
  const [role, setRole] = useState(null);
  
  // Filtre année
  const { selectedYear, setSelectedYear, availableYears } = useYearFilter();
  
  // États pour les données
  const [data, setData] = useState({
    totalCount: null,
    transactionsTotal: { volume: 0, count: 0 },
    totalAucPrivate: { totalCash: 0, count: 0 },
    totalAucPublic: { totalCash: 0, count: 0 },
  });
  
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(true);
  const [error, setError] = useState(null);
  
  // États pour les modals
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventForDetails, setSelectedEventForDetails] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedSecurityId, setSelectedSecurityId] = useState(null);

  // Chargement des données avec filtre année
  useEffect(() => {
    const fetchData = async () => {
      if (!selectedDomain?.id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const [count, volume, privateAuc, publicAuc] = await Promise.allSettled([
          fetchTotalCount(selectedDomain.id, selectedYear),
          getVolumeTransaction(selectedDomain.id, selectedYear),
          getTotalCashPrivate(selectedDomain.id, selectedYear),
          getTotalCashPublic(selectedDomain.id, selectedYear),
        ]);

        const newData = {
          totalCount: count.status === 'fulfilled' ? count.value : 0,
          transactionsTotal: volume.status === 'fulfilled' ? volume.value : { volume: 0, count: 0 },
          totalAucPrivate: privateAuc.status === 'fulfilled' ? privateAuc.value : { totalCash: 0, count: 0 },
          totalAucPublic: publicAuc.status === 'fulfilled' ? publicAuc.value : { totalCash: 0, count: 0 },
        };

        setData(newData);
        
        // Vérifier si on a des données pour l'année
        const hasDataForYear = (
          newData.totalCount > 0 ||
          newData.transactionsTotal.volume > 0 ||
          newData.totalAucPrivate.totalCash > 0 ||
          newData.totalAucPublic.totalCash > 0
        );
        
        setHasData(hasDataForYear);

        // Gérer les erreurs partielles
        const errors = [count, volume, privateAuc, publicAuc]
          .filter(result => result.status === 'rejected')
          .map(result => result.reason.message);

        if (errors.length > 0) {
          // console.warn('Certaines données n\'ont pas pu être chargées:', errors);
        }
      } catch (err) {
        setError(err.message);
        toast.error("Desole, une erreur s'est produite lors du chargement des données, Veillez verifier votre connexion internet et recommencer");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDomain, selectedYear, refresh]);

  // Récupération du rôle utilisateur
  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user || !selectedDomain) return;
      try {
        const fetchedRole = await getUserRole(user, selectedDomain);
        setRole(fetchedRole);
      } catch  {
        // toast.error("Erreur lors de la récupération du rôle");
        setRole("manager");
      }
    };

    fetchUserRole();
  }, [user, selectedDomain]);

  // Gestion des modals
  const openModal = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const modal = new bootstrap.Modal(el);
      modal.show();
    }
  };

  const closeModal = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const modal = bootstrap.Modal.getInstance(el);
      if (modal) modal.hide();
    }
  };

  // Actions des boutons
  const actions = [
    { 
      label: "Nouveau client", 
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z"/>
          <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z"/>
        </svg>
      ), 
      color: "primary", 
      onClick: () => openModal('newAccount'),
      disabled: loading
    },
    { 
      label: "Nouvel Ordre", 
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z"/>
          <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z"/>
        </svg>
      ), 
      color: "secondary", 
      onClick: () => openModal('newOrder'),
      disabled: loading
    },
    { 
      label: "Nouvel Événement", 
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z"/>
          <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z"/>
        </svg>
      ), 
      color: "success", 
      onClick: () => openModal('newEvent'),
      disabled: loading
    },
    { 
      label: "Nouvelle Transaction", 
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3C7.05 3 3 7.05 3 12C3 16.95 7.05 21 12 21C16.95 21 21 16.95 21 12C21 7.05 16.95 3 12 3ZM12 19.125C8.1 19.125 4.875 15.9 4.875 12C4.875 8.1 8.1 4.875 12 4.875C15.9 4.875 19.125 8.1 19.125 12C19.125 15.9 15.9 19.125 12 19.125Z"/>
          <path d="M16.3498 11.0251H12.9748V7.65009C12.9748 7.12509 12.5248 6.67509 11.9998 6.67509C11.4748 6.67509 11.0248 7.12509 11.0248 7.65009V11.0251H7.6498C7.1248 11.0251 6.6748 11.4751 6.6748 12.0001C6.6748 12.5251 7.1248 12.9751 7.6498 12.9751H11.0248V16.3501C11.0248 16.8751 11.4748 17.3251 11.9998 17.3251C12.5248 17.3251 12.9748 16.8751 12.9748 16.3501V12.9751H16.3498C16.8748 12.9751 17.3248 12.5251 17.3248 12.0001C17.3248 11.4751 16.8748 11.0251 16.3498 11.0251Z"/>
        </svg>
      ), 
      color: "danger", 
      onClick: () => openModal('newTransaction'),
      disabled: loading
    },
  ];

  // Ajouter l'action pour la sécurité
  actions.security = () => {
    setSelectedSecurityId(null);
    openModal('securityFormModal');
  };

  // Gestion du changement d'année
  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  // Gestion de la fermeture des modals avec rafraîchissement
  const handleModalClose = (modalId) => {
    closeModal(modalId);
    setRefresh(prev => !prev);
  };

  return (
    <Layout>
      <div className="content-body default-height">
        <div className="container-fluid">
          <DashboardHeader 
            actions={actions}
            role={role}
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
            availableYears={availableYears}
          />

          <CountersSection 
            data={data}
            loading={loading}
            selectedYear={selectedYear}
            hasData={hasData}
          />

          {/* Section des graphiques avec skeletons intégrés */}
          {hasData && !loading && (
            <div className="row">
              <ChartRepartitionClients selectedYear={selectedYear} />
              <ChartDonutTitle selectedYear={selectedYear} />
              <ChartDonutTransaction selectedYear={selectedYear} />
              
              <div className="mb-2">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title fw-bold text-primary-emphasis text-center text-uppercase fs-2" 
                      style={{ letterSpacing: "0.10em" }}>
                      Évolution des transactions Bourses 
                    </h4>
                  </div>
                  <div className="card-body m-0">
                    <CourbeWrapper selectedYear={selectedYear} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Message si pas de données pour les graphiques */}
          {!hasData && !loading && (
            <div className="row mt-2">
              <div className="col-12">
                <div className="card">
                  <div className="card-body text-center py-5">
                    <div className="empty-state">
                      <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.5">
                        <path d="M9 17h6m-6-4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <h4 className="mt-4 mb-2 text-dark">Aucun graphique disponible pour {selectedYear}</h4>
                      <p className="text-muted mb-4">
                        Les données statistiques et graphiques pour cette année ne sont pas encore disponibles.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Tableau des événements */}
          <TableDashboard
            refresh={refresh}
            selectedYear={selectedYear}
            onEditEvent={(event) => {
              setSelectedEvent(event);
              openModal('newEvent');
            }}
            onDetailsEvent={(event) => {
              setSelectedEventForDetails(event);
            }}
            onEditSecurity={(securityId) => {
              setSelectedSecurityId(securityId);
              openModal('securityFormModal');
            }}
          />
        </div>
      </div>

      {/* ==================== MODALS ==================== */}
      
      {/* Modal Nouveau Client */}
      <CustomerForm />
      
      {/* Modal Nouvel Ordre */}
      <OrderForm />
      
      {/* Modal RFI */}
      <FormulaireRfi />
      
      {/* Modal Événement */}
      <FormulaireEvenement
        editEvent={selectedEvent}
        onEventCreated={() => handleModalClose('newEvent')}
        onEventUpdated={() => handleModalClose('newEvent')}
      />

      {/* Modal Transaction */}
      <div className="modal fade" id="newTransaction" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <TransactionForm 
              closeModal={() => handleModalClose('newTransaction')} 
            />
          </div>
        </div>
      </div>
      
      {/* Modal Titre (Sécurité) */}
      <SecurityForm
        securityId={selectedSecurityId}
        modalId="securityFormModal"
        onSuccess={() => {
          setRefresh(prev => !prev);
          closeModal('securityFormModal');
        }}
        onClose={() => setSelectedSecurityId(null)}
      />
      
      {/* Modal Détails Événement */}
      {selectedEventForDetails && (
        <EventDetailsModal
          eventId={selectedEventForDetails.id}
          onClose={() => setSelectedEventForDetails(null)}
        />
      )}
    </Layout>
  );
};

export default DashboardPage;